import { rolesApi } from '../api/modules/roles.api';
import { getApiErrorMessage } from '../api/client';
import { USE_API } from '../config/api';
import { staffRoleSeed } from '../data/staff/roles';
import { roleFromApi } from '../models';

export async function listRoles(params = {}) {
  if (!USE_API) {
    let items = [...staffRoleSeed];
    if (params.search) {
      const q = String(params.search).toLowerCase();
      items = items.filter(
        (r) =>
          r.name?.toLowerCase().includes(q) ||
          r.roleId?.toLowerCase().includes(q),
      );
    }
    const page = params.page || 1;
    const pageSize = params.pageSize || items.length || 10;
    const start = (page - 1) * pageSize;
    return {
      items: items.slice(start, start + pageSize),
      total: items.length,
      page,
      pageSize,
    };
  }
  try {
    const result = await rolesApi.list(params);
    return {
      items: (result.items || []).map(roleFromApi),
      total: result.total ?? 0,
      page: result.page ?? 1,
      pageSize: result.pageSize ?? 10,
    };
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load roles'));
  }
}

export async function getRole(id) {
  if (!USE_API) {
    return staffRoleSeed.find((r) => r.roleId === id) || null;
  }
  try {
    return roleFromApi(await rolesApi.getById(id));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load role'));
  }
}

export async function createRole(body) {
  if (!USE_API) throw new Error('Create role requires API mode');
  try {
    return roleFromApi(await rolesApi.create(body));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to create role'));
  }
}

export async function updateRole(id, body) {
  if (!USE_API) throw new Error('Update role requires API mode');
  try {
    return roleFromApi(await rolesApi.update(id, body));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update role'));
  }
}

export async function updateRolePermissions(id, permissions) {
  if (!USE_API) throw new Error('Update role permissions requires API mode');
  try {
    return roleFromApi(await rolesApi.updatePermissions(id, permissions));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update permissions'));
  }
}

export async function deleteRole(id) {
  if (!USE_API) throw new Error('Delete role requires API mode');
  try {
    await rolesApi.remove(id);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to delete role'));
  }
}
